import { Button } from '@components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@components/ui/dialog';
import { Loader2 } from 'lucide-react';
import React from 'react';

interface ReassignConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentAssigneeName: string;
  targetAgentName: string;
  isPending: boolean;
  onConfirm: () => void;
}

export function ReassignConfirmDialog({
  open,
  onOpenChange,
  currentAssigneeName,
  targetAgentName,
  isPending,
  onConfirm,
}: ReassignConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={isPending ? undefined : onOpenChange}>
      <DialogContent className="sm:max-w-[440px]">
        <DialogHeader>
          <DialogTitle>Reassign case?</DialogTitle>
          <DialogDescription>
            Move this case from{' '}
            <span className="font-medium text-foreground">{currentAssigneeName}</span> to{' '}
            <span className="font-medium text-foreground">{targetAgentName}</span>. The assignee
            will be notified.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Confirm reassign
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
